export interface Location {
  country_name: string;
  continent: string;
  isocode: string;
  adresses?: Address[];
}
export interface Address {
  modified_on: string;
  latitude?: string;
  telephone_number?: string;
  fax_number?: string;
  url?: string;
  created_on: string;
  division_name: string;
  address_line_1: string;
  company_code: string;
  location: string;
  address_line_2: string;
  address_line_5: string;
  address_line_4: string;
  longitude?: number;
  country: string;
}

export enum LocationContinent {
  AFRICA = 'AFRICA',
  AMERICA = 'AMERICA',
  ASIA = 'ASIA',
  AUSTRALIA = 'AUSTRALIA',
  EUROPE = 'EUROPE',
  POPULAR = 'POPULAR',
}

export type LocationContinentKey = 'AFRICA' | 'AMERICA' | 'ASIA' | 'AUSTRALIA' | 'EUROPE' | 'POPULAR';

export const LocationContinentKeys = Object.keys(LocationContinent) as LocationContinentKey[];
export const LocationContinentValues = Object.values(LocationContinent);

export enum LocationCountry {
  CONTINENT = 'continent',
  COUNTRY_NAME = 'country_name',
  ISOCODE = 'isocode',
}

export type LocationCountryKey = 'CONTINENT' | 'COUNTRY_NAME' | 'ISOCODE';

export const LocationCountryKeys = Object.keys(LocationCountry) as LocationCountryKey[];
export const LocationCountryValues = Object.values(LocationCountry);

export const LocationPopularCountries: Record<LocationCountry, string>[] = [
  {
    continent: 'EUROPE',
    country_name: 'Austria',
    isocode: 'AT',
  },
  {
    country_name: 'Belgium',
    continent: 'EUROPE',
    isocode: 'BE',
  },
  {
    country_name: 'Brazil',
    continent: 'AMERICA',
    isocode: 'BR',
  },
  {
    country_name: 'France',
    continent: 'EUROPE',
    isocode: 'FR',
  },
  {
    country_name: 'Germany',
    continent: 'EUROPE',
    isocode: 'DE',
  },
  {
    country_name: 'Japan',
    continent: 'ASIA',
    isocode: 'JP',
  },
  {
    country_name: 'Spain',
    continent: 'EUROPE',
    isocode: 'ES',
  },
];
